import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CucmLicenseUsage } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class CucmLicenseUsageResource {
  private $http = inject(HttpClient);

  getCucmLicenseUsage(): Observable<CucmLicenseUsage> {
    return this.$http.get<CucmLicenseUsage>(
      `/services/cisco/reporting/license-optimizations/cucm-licenses?daysRecentlyCreated=30`,
    );
  }
}
